module.exports = __webpack_public_path__ + "static/media/btn_video_replay.660278ee.svg";